<dl class="contact-direct">
  <dt>Call or text</dt>
  <dd>
    <a [href]="phoneHref">{{ phone }}</a>
  </dd>
  <dt>Email</dt>
  <dd>
    <a [href]="emailHref">{{ email }}</a>
  </dd>
</dl>
